<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-payments-view :paymentStatuses="paymentStatuses"  />

    <core-footer />

  </v-app>
</template>

<script>

export default {
  name: 'ReviewPayments',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CorePaymentsView: () => import('../components/core/PaymentsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
    paymentStatuses: [
        'NEW',
        'ADMIN_REVIEW'
    ]
  }),
}
</script>
